/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type InquiryDetailResponseDtoApartmentRoomCategoriesItem = typeof InquiryDetailResponseDtoApartmentRoomCategoriesItem[keyof typeof InquiryDetailResponseDtoApartmentRoomCategoriesItem];


export const InquiryDetailResponseDtoApartmentRoomCategoriesItem = {
  STUDIO: 'STUDIO',
  ONE_OR_ONE_HALF: 'ONE_OR_ONE_HALF',
  TWO_OR_TWO_HALF: 'TWO_OR_TWO_HALF',
  THREE_OR_THREE_HALF: 'THREE_OR_THREE_HALF',
  FOUR_OR_FOUR_HALF: 'FOUR_OR_FOUR_HALF',
  FIVE_OR_MORE: 'FIVE_OR_MORE',
} as const;
